<div
  class="wrapper"
  #scrollWrapper
  [ngClass]="{ collapsed: isMenuCollapsed,fullPage:!hasUserInfo}"
  *ngIf="isTranslateLoaded"
>
  <div
    class="menu"
    *ngIf="isAgreementsEmpty && hasUserInfo"
    [ngClass]="{ collapsed: isMenuCollapsed, active: mobileNav }"
  >
    <app-nav-bar
      *ngIf="hasUserInfo"
      (mobileNavState)="mobNavClose($event)"
    ></app-nav-bar>
  </div>
  <div id="main-container" class="main-container">
    <div class="header" *ngIf="isAgreementsEmpty && hasUserInfo">
      <app-header></app-header>
    </div>
    <div class="main" #mainDiv [ngClass]="{ overflow: overFlowMainContainer }">
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="isAgreementsEmpty && hasUserInfo"></app-footer>
  
      <!-- <app-chatbot></app-chatbot> -->
 
  </div>

  <app-cbre-loader *ngIf="isLoaderVisible" [showOldLoader]="showOldLoader"></app-cbre-loader>

  <div
    class="sidenav"
    *ngIf="hasUserInfo && isAgreementsEmpty && enablePropertyFilter"
    [hidden]="!toggleFilterPanel"
  >
    <lib-pulse-filter-container></lib-pulse-filter-container>
  </div>
  <div
    *ngIf="toggleFilterPanel && isAgreementsEmpty"
    (click)="unmaskPage()"
    class="mask-page"
  ></div>
  <script-hack
    *ngIf="csWidgetJsUrl"
    [src]="csWidgetJsUrl"
    (onScriptLoadEvent)="onCSScriptLoadedEvent($event)"
    [isItWidgetUrl]="true"
  ></script-hack>
</div>
<!-- Chat-Bot -->
<!-- <app-chat-bot *ngIf="!hideChatBot && isAgreementsEmpty"></app-chat-bot> -->
<app-page-refresh-dialogue></app-page-refresh-dialogue>

<pulse-notification></pulse-notification>

<!-- To Do need to add this template through configuration like IF menu.template then load respective template -->
<ng-container *ngIf="showAddContactModalFlag">
  <lib-add-edit-contact
    isAddContact="true"
    (hideDialog)="toggleAddContactModal($event)"
  >
  </lib-add-edit-contact>
</ng-container>
<ng-container *ngIf="showAddDateModalFlag">
  <app-add-edit-date
    [isEditDate]="false"
    (hideDialog)="toggleAddDateModal($event)"
  >
  </app-add-edit-date>
</ng-container>
<ng-container *ngIf="showAddpropertyGroupModalFlag">
  <lib-add-edit-property-group
    [isEditGroup]="false"
    (hideDialog)="toggleAddPropertyGroupModal($event)"
  >
  </lib-add-edit-property-group>
</ng-container>

<ng-container *ngIf="showAddDocModalFlag">
  <app-add-document (hideDialog)="toggleAddDocModal($event)">
  </app-add-document>
</ng-container> 
